<template>
  <div>
    <Header title="教室借用详情"></Header>
    <div class="Detail_box">
      <h3 :style="{ color: color1 }">{{ form.state }}</h3>
      <p class="lesson">{{ form.courseName }}</p>
      <p>
        借用周次：<span>{{ form.weekly }}</span>
      </p>
      <p>
        借用星期：<span>{{ form.dayweek }}</span>
      </p>
      <p v-if="schoolCode != '14075'">
        教室容量：<span>{{ form.classroomCapacity }}</span>
      </p>
      <p>
        起止节次：<span>{{ form.node }}</span>
      </p>
      <p>
        校区：<span>{{ form.campus }}</span>
      </p>
      <p>
        教学楼：<span>{{ form.tchBuilding }}</span>
      </p>
      <p>
        教室：<span>{{ form.jsmc }}</span>
      </p>
      <p>
        联系电话：<span>{{ form.phone }}</span>
      </p>
      <p v-if="schoolCode == '10422'">
        使用多媒体：<span>{{ form.sydmt }}</span>
      </p>
      <p v-if="schoolCode == '10422'">
        申请事由：<span>{{ form.remarks }}</span>
      </p>
      <p v-else>
        {{ schoolCode == "10013" ? "活动说明：" : "备注："
        }}<span>{{ form.remarks }}</span>
      </p>
      <p v-if="schoolCode == '10054'">
        借用原因：<span>{{ form.jyreson }}</span>
      </p>
      <p v-if="schoolCode == '10054'">
        补课课程：<span>{{ form.bkkc }}</span>
      </p>

      <!-- <p>借用流程说明：<span>{{form.jylcsm}}</span></p> -->
    </div>
    <div v-if="schoolCode == '14075'" class="fo">
      <button @click="revoke()"
       :disabled="this.sfkcx == '0'"
       :style="this.sfkcx == '0' ? 'background-color:#DADADA' : '' ">撤销</button>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Api } from '../../../utils/axios';
export default {
  data() {
    return {
      schoolCode: "",
      weekly: "",
      courseName: "",
      dayweek: "",
      classroomCapacity: "",
      node: "",
      campus: "",
      state: "",
      remarks: "",
      tchBuilding: "",
      color1: "",
      phone: "",
      jsmc: "",
      sfkcx: "0",
      overtimer: null,
      ywinstanceid:"",
      form: {}
    };
  },
  async created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");

    this.ywinstanceid = this.$route.query.ywinstanceid;
    if (this.ywinstanceid && this.schoolCode === "13383") {
      const res = await Api.teachMyBorrowingClassrooms({ywinstanceid:this.ywinstanceid})
      this.form=res.data[0]
    } else {
      this.form = JSON.parse(decodeURIComponent(this.$route.query.e));
      this.weekly = this.$route.query.weekly;
      this.courseName = this.$route.query.courseName;
      this.phone = this.$route.query.phone;
      this.dayweek = this.$route.query.dayweek;
      this.classroomCapacity = this.$route.query.classroomCapacity;
      this.node = this.$route.query.node;
      this.campus = this.$route.query.campus;
      this.state = this.$route.query.state;
      this.remarks = this.$route.query.remarks;
      this.tchBuilding = this.$route.query.tchBuilding;
      this.jsmc = this.$route.query.jsmc;
    }


    // this.weekly = this.$route.query.weekly;
    if (this.form.state == "审核通过") {
      this.sfkcx = "0";
      this.color1 = "#12DDD6";
    } else if (this.form.state == "申请失败") {
      this.sfkcx = "0";
      this.color1 = "#F86969";
    } else if (this.form.state == "待审核") {
      this.sfkcx = "1";
      this.color1 = "#7469F8";
    } else if (this.form.state == "待送审") {
      this.sfkcx = "0";
      this.color1 = "#757DA3";
    }
  },
  methods: {
    async revoke() {
      Dialog.confirm({
        message: "确定要撤销该申请吗?"
      }).then(() => {
        this.revokeSub();
      }).catch(() => {});
    },
    async revokeSub(){
      let formData = {
        shid: this.form.ywinstanceid,
        jyid: this.form.jsjyid
      };
      const res = await Api.revokeJsjy(formData);
      this.state = res.data;
      if (res.code == "0") {
         this.$toast.fail(res.Msg);
      } else {
        this.$toast.fail("撤销成功！");
        this.overtimer = setTimeout(() => {
          this.$router.replace({
            path: "/bList"
          });
        },1000)
      }
    }
  },
  beforeDestroy() {
    this.overtimer && clearTimeout(this.overtimer);
    this.overtimer = null;
  }
};
</script>
<style lang="less" scoped>
.Detail_box {
  width: 90%;
  margin-left: 5%;
}
.Detail_box h3 {
  font-size: 24px;
  margin-top: 25px;
  /* color: #7469F8 */
}
.Detail_box .lesson {
  color: @attendance-color-1;
  font-size: 18px;
  margin-top: 20px;
  font-weight: 600;
}
.Detail_box p {
  color: @attendance-color-2;
  font-size: 14px;
}
.Detail_box p span {
  font-weight: 700;
  word-wrap: break-word;
}
.Detail_box p {
  margin-top: 8px;
}
.fo {
  width: 90%;
  margin-left: 5%;
}
.fo button {
  display: block;
  text-align: center;
  line-height: 44px;
  width: 40%;
  height: 44px;
  background: @attendance-background-color-1;
  color: @attendance-color-3;
  font-size: 16px;
  border-radius: 3px;
  position: fixed;
  bottom: 20px;
  left: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Classroom/recordDetail.vue